var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.auth.userType === 'businessman')?_c('dashBusinessman'):(_vm.HAS_ROLES('ROLE_ULTRAADMIN'))?_c('dashSuperAdmin'):_c('dash-main-courses')}
var staticRenderFns = []

export { render, staticRenderFns }